<template>
  <div v-if="!showDetails">
    <app-history @clicked="$router.push('/ezamrequest-history')" />
    <v-card class="form" v-if="plans.length > 0">
      <app-tarh v-for="index in plans.length" :key="index" :index="index - 1" :tarh="plans[index - 1]"
        :showDetails="false" @clicked="onClickRegister">
      </app-tarh>
    </v-card>
    <div v-else-if="!loadTarh" style="margin: 20px">در حال حاضر هیچ طرح فعالی وجود ندارد.</div>
    <div v-else-if="!canSelectTarh" style="margin: 20px">پرونده تبلیغی برای شما موجود نیست.</div>
    <div v-else style="margin: 20px">در حال بارگذاری طرح ها...</div>

  </div>
  <div v-else>
    <v-card>
      <v-card-title class="info-title">
        <div class="text-center">
          {{ selectedTarh.Title }}
        </div>
      </v-card-title>
      <app-row v-if="selectedTarh.Description" title="توضیحات" :value="selectedTarh.Description" />

      <div style="margin: 0 25px 0; padding: 10px 0 0">
        <h4>شرایط:</h4>
        <div style="
            border: 2px solid #996910;
            border-radius: 15px;
            margin: 15px 15px 0;
          ">
          <app-row title="حداقل پایه" :value="selectedTarh.PayehName" />
          <app-row title="جنسیت" :value="selectedTarh.Jensiat == 1
            ? 'آقا'
            : selectedTarh.Jensiat == 2
              ? 'خانم'
              : 'هردو'
            " />
          <app-row title="نیاز به تلبس" :value="selectedTarh.IsNeedTalabbos == 1 ? 'بله' : 'خیر'" />
          <app-row title="نیاز به تاهل" :value="selectedTarh.IsNeedTaahol == 1 ? 'بله' : 'خیر'" />
          <app-row title="نیاز به تایید مدرسه" :value="selectedTarh.IsNeedSchool == 1 ? 'بله' : 'خیر'" />
        </div>
      </div>
      <div class="form" v-if="selectedTarh.CanEzam">
        <v-row align="center" style="margin-top: 10px">
          <v-col class="d-flex" cols="12" sm="6" lg="2">
            <b>شهر محل تبلیغ:</b>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12" lg="10">
            <v-autocomplete v-model="selectedCity" :items="cities" :loading="loading" :search-input.sync="search"
              item-text="FullName" item-value="id" return-object no-filter :no-data-text="getHint()" />
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="4" md="2" style="margin-top: 10px">
            <b>آدرس محل تبلیغ:</b>
          </v-col>
          <v-col class="d-flex" cols="12" sm="8" md="7">

            <v-text-field v-model="mahalTitle"></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12" sm="12" md="3" style="justify-content: center;">
            <v-btn class="form-center" color="blue white--text" rounded @click="showMapDialog = true"
              style="max-width: 250px;">
              {{ "انتخاب از روی نقشه" }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6" md="3">
            <b>تاریخ شروع تبلیغ:</b>
          </v-col>
          <v-col class="d-flex" cols="12" sm="6" md="3">
            <v-btn class="form-center" color="red white--text" rounded @click="onClickDate(1)">
              {{ startSelected ? startDate : "انتخاب تاریخ" }}
            </v-btn>

          </v-col>
        </v-row>
        <v-row align="center">
          <v-col class="d-flex" cols="12" sm="6" md="3">
            <b>تاریخ پایان تبلیغ:</b>
          </v-col>
          <v-col class="d-flex" cols="12" sm="6" md="3">
            <v-btn class="form-center" color="red white--text" rounded @click="onClickDate(2)">
              {{ endSelected ? endDate : "انتخاب تاریخ" }}
            </v-btn>

          </v-col>
        </v-row>
        <v-row style="margin-top: 25px">
          <v-col class="d-flex" cols="12">
            <b>ملاحظات:</b>
          </v-col>
          <v-col class="d-flex" cols="12">
            <v-textarea outlined v-model="description" no-resize style="margin: 15px 15px 0"
              placeholder="اگر شرایط خاصی مدنظر شما است بفرمایید."></v-textarea>
          </v-col>
        </v-row>

        <v-row class="ltr">
          <v-btn color="primary white--text" class="register" rounded @click="showConfirm">
            ثبت درخواست
          </v-btn>
        </v-row>
      </div>
      <div class="HasRegistered" v-else>
        {{
          isHistory
            ? "شما پیشتر برای این طرح درخواست نموده اید."
            : "درخواست با موفقیت ثبت شد. "
        }}
        برای مشاهده اطلاعات بیشتر به بخش
        <a href="/ezamrequest-history"> مشاهده سوابق </a>
        مراجعه کنید.
      </div>
      <date-picker ref="datepicker1" v-model="startDate" :editable="false" :auto-submit="true" element="fileInput1"
        :min="today" @change="onChangeDate($event, 1)"></date-picker>
      <input id="fileInput1" ref="fileInput1" />
      <date-picker ref="datepicker2" v-model="endDate" :editable="false" :auto-submit="true" element="fileInput2"
        :min="today" @change="onChangeDate($event, 2)"></date-picker>
      <input id="fileInput2" ref="fileInput2" />

    </v-card>
    <v-dialog v-model="showMapDialog" max-width="600" persistent>
      <v-card style="padding-top: 1px">
        <v-card-title>
          انتخاب از روی نقشه
        </v-card-title>
        <leaflet-map ref="leafletMap" :center="coordinate ?? center" :coordinate="coordinate"
          @mapClick="handleMapClick" />

        <v-card-actions style="direction: ltr">
          <v-btn class="register" color="primary white--text" rounded @click="showMapDialog = false">
            بستن
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showConfirmDialog" max-width="600" persistent content-class="myDialog">
      <v-card-title><b> آیا از این درخواست تبلیغ اطمینان دارید؟</b></v-card-title>

      <v-row align="center" v-if="selectedTarh.TaahodNameh">
        <v-col class="d-flex" cols="12"> <b>تعهدنامه</b></v-col>
        <v-col class="d-flex" cols="12">
          <span v-html="selectedTarh.Taahod"></span>
        </v-col>
      </v-row>

      <v-row class="ltr">
        <v-btn class="register" color="red white--text" rounded @click="showConfirmDialog = false">
          بستن
        </v-btn>


        <v-btn class="register" color="primary white--text" rounded @click="applyRequest">
          پذیرش تبلیغ
        </v-btn>
      </v-row>
    </v-dialog>
  </div>
</template>

<script>
import Tarh from "../jazb/Tarh";
import DetailRow from "@/components/DetailRow";
import HistoryButton from "@/components/HistoryButton";
import { getAllTarh } from "@/api/jazb";
import { canSendRequest, SaveRequest } from "@/api/ezamrequest";
import moment from "moment-jalaali";

import { cityAutoComplete } from "@/api/location";
import { TODAY } from "@/utils/constants";
import Leaflet from '../../components/Leaflet';


export default {
  data() {
    return {
      today: TODAY,
      selectedCity: null,

      search: "",

      cities: [],

      loading: false,

      debounceTimer: null,
      plans: [],
      selectedIndex: -1,
      description: "",
      isHistory: true,

      mahalTitle: "",
      startDate: "",
      endDate: "",
      startSelected: false,
      endSelected: false,
      center: [36.2972, 59.6067],
      coordinate: null,
      showMapDialog: false,
      canSelectTarh: true,
      loadTarh: true,
      showConfirmDialog: false
    };
  },
  components: {
    appTarh: Tarh,
    appRow: DetailRow,
    appHistory: HistoryButton,
    LeafletMap: Leaflet,
  },
  created() {
    if (this.$route.query.index) {
      this.$router.replace({
        query: {}
      })
    }
    this.checkrequest();

  },

  computed: {
    showDetails() {
      return this.selectedIndex > -1;
    },
    selectedTarh() {
      return this.selectedIndex != -1 ? this.plans[this.selectedIndex] : {};
    },

  },
  methods: {
    onClickDate(input) {
      if (input == 1) {
        this.$refs.fileInput1.click();
      } else {
        this.$refs.fileInput2.click();
      }
    },
    onChangeDate($event, input) {
      let date = moment($event).format("jYYYY/jMM/jDD");
      if (input == 1) {
        this.startDate = date;
        this.startSelected = true;
      } else {
        this.endDate = date;
        this.endSelected = true;
      }
    },
    getHint() {
      if (this.loading) {
        return "در حال جستجو..."
      } else if (!this.search || this.search.length < 3) {
        return 'لطفا بخشی از نام استان، شهر، بخش یا روستا را وارد نمایید.'
      } else {
        return 'مکانی یافت نشد.'
      }
    },
    handleMapClick(latlng) {
      console.log("Clicked:", latlng);

      // update marker position
      this.coordinate = latlng;
    },
    /**
     * show available classes
     */
    getTarhha() {
      return new Promise((resolve, reject) => {
        getAllTarh(true)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }
            this.plans = response.data;
            this.loadTarh = false
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    checkrequest() {
      return new Promise((resolve, reject) => {
        canSendRequest()
          .then((response) => {
            if (response.data === true) {
              this.getTarhha();
            } else if (response.data === false) {

            }
            this.canSelectTarh = response.data
            if (!response.data) {
              reject("error");
            }


            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            reject(error);
          });
      });
    },
    CityAutoComplete(query) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        cityAutoComplete(query)
          .then((response) => {
            if (!response.data) {
              reject("error");
            }

            this.cities = response.data;

            this.loading = false
            resolve(response);
          })
          .catch((error) => {
            console.log(error);
            this.loading = false

            reject(error);
          });
      });
    },
    onClickRegister(index) {


      window.scrollTo(0, 0);
      this.$router.push({
        query: {

          index: index
        }
      });
    },
    /**
     * check user input and  then send khorooj request
     */
    replaceNewLine(description) {
      const str = description.replace(/(?:\r\n|\r|\n)/g, "<br>");
      return str;
    },
    applyRequest() {

      this.showConfirmDialog = false
      SaveRequest({
        Srl_Tarh: this.selectedTarh.Fserial,
        Des_Fard: this.replaceNewLine(this.description),
        cityId: this.selectedCity.Id,
        MahalTitle: this.mahalTitle,
        Local_X: this.coordinate ? Math.round(this.coordinate[1] * 10000000) / 10000000 : null,
        Local_Y: this.coordinate ? Math.round(this.coordinate[0] * 10000000) / 10000000 : null,
        D_StartEzam: this.startDate,
        D_EndEzam: this.endDate,
      })
        .then((response) => {
          const data = response.data;
          this.$store.commit("SET_SNACKBAR_TEXT", data.Message);
          this.isHistory = false;
          this.getTarhha();
        })

        .catch((error) => {
          this.$store.commit(
            "SET_SNACKBAR_TEXT",
            "خطایی به وجود آمده است لطفا مجددا تلاش کنید."
          );
        });
    },

    showConfirm() {
      if (this.selectedCity == null) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          " شهر محل تبلیغ  بایستی انتخاب شود."
        );
        return;
      }
      if (!this.selectedCity.FullName.startsWith("خراسان")) {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          " شهر محل تبليغ خارج از محدوده اعزام مي‌باشد"
        );
        return;
      }

      if (this.mahalTitle == "") {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          "  آدرس بایستی انتخاب شود."
        );
        return;
      }
      if (this.startDate == "") {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          " تاریخ شروع تبلیغ  بایستی انتخاب شود."
        );
        return;
      }
      if (this.endDate == "") {
        this.$store.commit(
          "SET_SNACKBAR_TEXT",
          " تاریخ پایان تبلیغ  بایستی انتخاب شود."
        );
        return;
      }
      this.showConfirmDialog = true;
    }
  },
  watch: {

    '$route'(to, from) {
      this.selectedIndex = this.$route.query.index ?? -1;

    },
    showMapDialog(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            if (this.$refs.leafletMap) {
              this.$refs.leafletMap.invalidateMapSize();
            }
          }, 100);
        });
      }
    },
    search(val) {
      if (
        this.selectedCity &&
        val === this.selectedCity.FullName
      ) {
        return;
      }
      if (!val || val.length < 3) {
        this.selectedCity = null
        this.cities = [];
        return;
      }

      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.CityAutoComplete(val);
      }, 400);
    },
  },
};
</script>
<style scoped>
.form {
  display: flow-root;
}

.HasRegistered {
  margin: 25px;
  text-align: center;
  padding: 15px 15px;
  color: black;
  /* border: 3px solid #0f2204;
  border-radius: 15px; */
  font-weight: bold;
  display: inline-block;
  text-align: justify;
  font-size: 90%;
}
</style>
